export const KINDS_WITH_MANDATORY_ATTRIBUTES = [
  'custom',
  'inbound_call',
  'outbound_call',
  'physical'
]

export const INTEGRATIONS = [
  'zoom_conference',
  'gotomeeting_conference',
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference'
]

export const PHONE_CALL_KINDS = {
  outbound: 'outbound_call',
  inbound: 'inbound_call'
}

export const NON_EXCLUSIVE_LOCATIONS = [
  'physical',
  'custom'
]
